import { DomBldFuncPlot } from "../../../../content/wiskunde/functies/domein_beeld/drawings/plots";
import { DomBldFuncDomain, DomBldFuncRange } from "../../../../content/wiskunde/functies/domein_beeld/drawings/plots";
import * as React from 'react';
export default {
  DomBldFuncPlot,
  DomBldFuncDomain,
  DomBldFuncRange,
  React
};